import React, {createContext, FC, useEffect, useRef} from 'react';

interface RenderCondition {
	isSSR: boolean;
	isHydration: boolean;
	isInitial: boolean;
}

const initialRenderCondition: RenderCondition = {
	isSSR: false,
	isHydration: false,
	isInitial: false,
};

export const RenderConditionContext = createContext<{current: RenderCondition}>({
	current: initialRenderCondition,
});

/**
 * Provides render conditions and resets them after the first rendering on the client side.
 */
export const RenderConditionProvider: FC<{isHydration: boolean; isSSR?: boolean}> = ({
	isHydration,
	isSSR = false,
	children,
}) => {
	const value = useRef<RenderCondition>({
		isSSR,
		isHydration,
		isInitial: true,
	});

	useEffect(() => {
		value.current = initialRenderCondition;
	});

	return <RenderConditionContext.Provider value={value}>{children}</RenderConditionContext.Provider>;
};
